module.exports = __webpack_public_path__ + "img/automotriz.ad113a45.png";